import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "numberPlusMinus" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "center" }
const _hoisted_5 = { class: "right" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_minus = _resolveComponent("icon-minus")!
  const _component_icon_plus = _resolveComponent("icon-plus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
        disabled: _ctx.localValue <= 0
      }, [
        _createVNode(_component_icon_minus)
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.localValue), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
        disabled: _ctx.localValue >= _ctx.max
      }, [
        _createVNode(_component_icon_plus)
      ], 8, _hoisted_6)
    ])
  ]))
}